import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExploreError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 384,
	height: 459,
	viewBox: "0 0 384 459",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ddddd_11914_15394)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 116,
				y: 18,
				width: 240,
				height: 240,
				rx: 43.5817,
				fill: "#0D26BB"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M189.715 209.455H167.516V227.108H189.715V209.455Z",
			fill: "url(#paint0_linear_11914_15394)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M167.517 203.894C172.646 203.894 176.803 208.051 176.803 213.18V258.106H158.23V213.18C158.23 208.051 162.388 203.894 167.517 203.894Z",
			fill: "url(#paint1_linear_11914_15394)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M282.594 227.108H304.793V209.455H282.594V227.108Z",
			fill: "url(#paint2_linear_11914_15394)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M314.078 258.104H295.506V213.177C295.506 208.053 299.665 203.891 304.792 203.891C309.916 203.891 314.078 208.051 314.078 213.177V258.104Z",
			fill: "url(#paint3_linear_11914_15394)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M245.44 162.326H226.867V186.78H245.44V162.326Z",
			fill: "url(#paint4_linear_11914_15394)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236.155 158.574C272.126 158.574 301.287 146.794 301.287 132.263C301.287 117.732 272.126 105.953 236.155 105.953C200.184 105.953 171.023 117.732 171.023 132.263C171.023 146.794 200.184 158.574 236.155 158.574Z",
			fill: "url(#paint5_linear_11914_15394)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236.154 176.527C266.342 176.527 290.815 156.709 290.815 132.263C290.815 107.817 266.342 88 236.154 88C205.965 88 181.492 107.817 181.492 132.263C181.492 156.709 205.965 176.527 236.154 176.527Z",
			fill: "url(#paint6_linear_11914_15394)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.102 116.749H210.212C201.68 116.749 194.699 123.73 194.699 132.261C194.699 140.792 201.68 147.773 210.212 147.773H262.102C270.634 147.773 277.615 140.792 277.615 132.261C277.615 123.73 270.634 116.749 262.102 116.749Z",
			fill: "url(#paint7_linear_11914_15394)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M206.904 127.404L216.097 136.596",
			stroke: "#84A5FB",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.096 127.404L206.903 136.596",
			stroke: "#84A5FB",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.598 127.404L265.79 136.596",
			stroke: "#84A5FB",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M265.789 127.404L256.597 136.596",
			stroke: "#84A5FB",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236.154 183.047C205.965 183.047 181.492 197.123 181.492 214.487V258.109H290.817V214.487C290.817 197.123 266.344 183.047 236.156 183.047H236.154Z",
			fill: "url(#paint8_linear_11914_15394)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 160H253",
			stroke: "#0D26BB",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M305.191 66.002L300.341 90.4729L308.7 84.9921L309.81 103.998L317.066 72.7567L307.574 80.0145L305.191 66.002Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.744 118.539L154.522 134.963L144.555 135.724L155.274 151.457L130.46 131.137L142.409 131.093L135.744 118.539Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_ddddd_11914_15394)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M187.571 37H112.429C105.043 37 99 41.939 99 47.9767V84.0309C99 90.0685 105.043 95.0075 112.429 95.0075H157.221C157.501 95.0075 157.768 95.125 157.958 95.3315L167.844 106.107C168.461 106.779 169.581 106.343 169.581 105.431V96.0075C169.581 95.4552 170.029 95.0075 170.581 95.0075H187.571C194.957 95.0075 201 90.0685 201 84.0309V47.9767C201 41.939 194.957 37 187.571 37Z",
				fill: "#EDF4FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.553 72V59.328H135.887V61.722H130.181V64.188H134.879V66.582H130.181V69.606H136.319V72H127.553ZM138.333 72V62.838H140.853V64.71C141.177 63.504 142.167 62.622 143.391 62.622C143.841 62.622 144.363 62.73 144.795 62.964V65.358C144.291 65.052 143.715 64.962 143.247 64.962C141.915 64.962 140.871 66.096 140.853 67.896V72H138.333ZM146.643 72V62.838H149.163V64.71C149.487 63.504 150.477 62.622 151.701 62.622C152.151 62.622 152.673 62.73 153.105 62.964V65.358C152.601 65.052 152.025 64.962 151.557 64.962C150.225 64.962 149.181 66.096 149.163 67.896V72H146.643ZM159.046 72.216C156.238 72.216 154.078 70.128 154.078 67.428C154.078 64.692 156.238 62.622 159.046 62.622C161.836 62.622 164.014 64.692 164.014 67.428C164.014 70.128 161.836 72.216 159.046 72.216ZM156.634 67.428C156.634 68.868 157.678 69.93 159.046 69.93C160.414 69.93 161.458 68.868 161.458 67.428C161.458 65.988 160.414 64.908 159.046 64.908C157.678 64.908 156.634 65.988 156.634 67.428ZM166.198 72V62.838H168.718V64.71C169.042 63.504 170.032 62.622 171.256 62.622C171.706 62.622 172.228 62.73 172.66 62.964V65.358C172.156 65.052 171.58 64.962 171.112 64.962C169.78 64.962 168.736 66.096 168.718 67.896V72H166.198Z",
			fill: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M369.002 65L330.605 101.77L352.368 94.9086L329 128L377 83.3202L360.059 84.9281L369.002 65Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_ddddd_11914_15394",
				x: 17.9412,
				y: 5.74265,
				width: 365.297,
				height: 452.461,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -2.72386,
						dy: 8.17157
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10.2145 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_11914_15394",
						result: "effect2_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -9.53349,
						dy: 35.4101
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 18.386 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_11914_15394",
						result: "effect3_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -21.7908,
						dy: 78.9918
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24.5147 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_11914_15394",
						result: "effect4_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -39.4959,
						dy: 141.641
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 29.2814 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_11914_15394",
						result: "effect5_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_11914_15394",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_ddddd_11914_15394",
				x: .941204,
				y: 24.7426,
				width: 227.297,
				height: 281.894,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -2.72386,
						dy: 8.17157
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10.2145 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_11914_15394",
						result: "effect2_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -9.53349,
						dy: 35.4101
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 18.386 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_11914_15394",
						result: "effect3_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -21.7908,
						dy: 78.9918
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24.5147 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_11914_15394",
						result: "effect4_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -39.4959,
						dy: 141.641
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 29.2814 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.780392 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_11914_15394",
						result: "effect5_dropShadow_11914_15394"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_11914_15394",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_11914_15394",
				x1: 279.633,
				y1: 290.976,
				x2: 183.747,
				y2: 221.975,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_11914_15394",
				x1: 119.561,
				y1: 186.867,
				x2: 209.022,
				y2: 274.21,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_11914_15394",
				x1: 192.675,
				y1: 290.976,
				x2: 288.562,
				y2: 221.975,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_11914_15394",
				x1: 352.747,
				y1: 186.867,
				x2: 263.287,
				y2: 274.21,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_11914_15394",
				x1: 340.829,
				y1: 249.881,
				x2: 241.471,
				y2: 178.379,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_11914_15394",
				x1: 174.518,
				y1: 50.0783,
				x2: 239.432,
				y2: 136.63,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_11914_15394",
				x1: 189.959,
				y1: 85.9093,
				x2: 310.055,
				y2: 206.419,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_11914_15394",
				x1: 193.026,
				y1: 74.7566,
				x2: 238.449,
				y2: 135.319,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4222D0" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#070256"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_11914_15394",
				x1: 120.166,
				y1: 118.762,
				x2: 336.557,
				y2: 330.031,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6DDF8"
				})]
			})
		] })
	]
});
export default SvgExploreError;
